export default __webpack_public_path__ + "static/media/CV.b600c8ad.pdf";